import { ChangeEvent, useMemo } from "react";
import { useTranslation } from "react-i18next";
import FlagBrazil from '../../../assets/img/brazil-flag.png';
import FlagEnglish from '../../../assets/img/english-flag.png';
import FlagTurkey from '../../../assets/img/turkey-flag.png';
import { Select, MenuItem, FormControl, InputLabel, Box } from '@mui/material';
import { styled } from '@mui/system';

const languageOptions = ['pt-BR', 'en-US', 'tr-TR'] as const;

type LanguageOption = (typeof languageOptions)[number];

const flags: Record<LanguageOption, string> = {
  'pt-BR': FlagBrazil,
  'en-US': FlagEnglish,
  'tr-TR': FlagTurkey,
};

const labels: Record<LanguageOption, string> = {
  'pt-BR': 'Português',
  'en-US': 'English',
  'tr-TR': 'Türkçe',
};

const StyledFlag = styled('img')({
  width: 24,
  height: 24,
  marginRight: 24,
});

export default function LanguageSwitch() {
  const { i18n } = useTranslation();

  const handleChange = (event: any) => {
    const selectedLanguage = event.target.value as LanguageOption;
    i18n.changeLanguage(selectedLanguage);
  };

  return (
    <FormControl variant="outlined">
      <InputLabel id="language-selector-label">Language</InputLabel>
      <Select
        labelId="language-selector-label"
        value={i18n.language}
        onChange={handleChange}
        label="Language"
        renderValue={(selected) => (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <StyledFlag src={flags[selected as LanguageOption]} alt={labels[selected as LanguageOption]} />
            {labels[selected as LanguageOption]}
          </Box>
        )}
      >
        {languageOptions.map((lang) => (
          <MenuItem key={lang} value={lang}>
            <StyledFlag src={flags[lang]} alt={labels[lang]} />
            {labels[lang]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
